import { useContext } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./styles/globals.css";
import { UrlProvider } from "./contexts/UrlContext";

import ReactGA from "react-ga4";

import { ClientContext, ClientProvider } from "./contexts/ClientContext";
import ClientProfile from "./pages/ClientProfiles";
import ClientFeedback from "./pages/ClientFeedback";
import PageNotFound from "./pages/PageNotFound";
import ClientError from "./components/Client/SharedProfiles/clientError";
import ConsultantLoading from "./components/Client/SharedProfiles/ConsultantLoading";

// e.g. "/12/feedback&code=bad" matches no route; show the validation result instead of a blank page
function UnmatchedLink() {
  const { loading, error } = useContext(ClientContext);
  if (loading) return <ConsultantLoading />;
  return <ClientError msg={error || "This link is not valid"} />;
}

let URI;
if (process.env.REACT_APP_ENVIRONMENT === "development") {
  URI = "https://expertpowerhouse.com:3001/";
} else if (process.env.REACT_APP_ENVIRONMENT === "production") {
  URI = "https://expertpowerhouse.com/";
} else {
  URI = "http://localhost:3000/";
}

ReactGA.initialize("G-R701RR6DZJ");

export default function App() {
  return (
    <BrowserRouter>
      <UrlProvider>
        <Routes>
          <Route
            path="/*"
            element={
              <ClientProvider>
                <Routes>
                  {/* <Route index element={<Consultant />} />
                      <Route path=":code" element={<Consultant />} /> */}
                  <Route path="/:projectID" element={<ClientProfile />} />
                  <Route path="/:projectID/feedback" element={<ClientFeedback />} />
                  <Route path="*" element={<UnmatchedLink />} />
                </Routes>
              </ClientProvider>
            }
          />
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </UrlProvider>
    </BrowserRouter>
  );
}
